import { Redeem } from "@mui/icons-material";
import { useStore } from "@priolo/jon";
import { FunctionComponent, useState } from "react";
import querySo from "stores/route/query";
import { URL_PAR } from "stores/route/utils/types";
import MultiSelectorDialogBase2 from "../base/MultiSelectorDialogBase2";
import Chip from "./Chip";
import { statusAll, getIsDefault, statusDefault } from "stores/cycle/utils/fetch";



interface Props {
	sx?: any
}

const SelectorCycleStatusH: FunctionComponent<Props> = ({
	sx,
}) => {

	// STORE
	useStore(querySo)

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)
	let [selected, setSelected] = useState(() => {
		const [statusSel] = querySo.getSearchUrl([URL_PAR.CYCLE_STATUS])
		if (statusSel == null) return []
		return statusSel.split("-").map(i => statusAll[+i])
	})

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (selected: string[]) => {
		setIsOpen(false)
		if (selected == null) return

		setSelected(selected)
		const selectedUrl = getIsDefault(selected) ? "" : selected.map(s => statusAll.indexOf(s).toString()).join("-")
		querySo.setSearchUrl([URL_PAR.CYCLE_STATUS, selectedUrl])
	}
	const handleClear = (e) => {
		e.stopPropagation()
		handleClose([])
	}


	// RENDER
	
	const isDefault = getIsDefault(selected)
	selected = isDefault ? statusDefault : selected
	const label = isDefault ? "DEFAULT" : selected.length == 1 ? selected[0] : `${selected.length} STATUS`
	const tooltip = selected.join(", ")

	return (<>

		<Chip sx={sx}
			label={label}
			icon={<Redeem />}
			tooltip={tooltip}
			active={!isDefault}
			onClick={handleClick}
			onClear={handleClear}
		/>

		<MultiSelectorDialogBase2 noSpace
			
			width={280}
			height={null}
			icon={<Redeem />}
			title={"SELECT STATUS"}

			items={statusAll}
			itemsSelect={selected}

			fnIdFromItem={(item) => item}
			fnTextFromItem={(item) => item}

			isOpen={isOpen}
			onClose={handleClose}
		/>

	</>)
}

export default SelectorCycleStatusH


